import React from "react";
// import SelectSearch from "react-select-search";
import jsonStocksList from "./stocks.json";
import jsonindicessList from "./indices.json";

import Select from "react-select";
import AsyncSelect from "react-select/async";
import "./TickerSearchBox.css";
// const options = stocks;
const stocks = JSON.parse(JSON.stringify(jsonStocksList));
const indices = JSON.parse(JSON.stringify(jsonindicessList));

const options = [...stocks, ...indices];

const default_options = ["INFY", "WIPRO"];

const loadOptions = (inputValue, callback) => {
  // perform a request
  const requestResults = options;

  callback(requestResults);
};

const customStyles = {
  option: (provided, state) => ({
    ...provided,
  }),
  control: (provided, state) => ({
    ...provided,
    width: 800,
    // none of react-select's styles are passed to <Control />
  }),
  singleValue: (provided, state) => {
    return { ...provided };
  },
};

const containerStyles = {
  paddingTop: "200",
  paddingBottom: "200",
};

const TickerSearchBox = (props) => (
  <div
    data-testid="TickerSearchBox"
    styles={{
      padding: 50,
    }}
  >
    {/* <AsyncSelect
      loadOptions={loadOptions}
      isMulti
      onChange={(opt) => console.log(opt)}
    /> */}
    <Select
      placeholder="Search Ticker"
      options={options}
      isMulti
      onChange={props.setTickers}
      className="searchSelect"
      // styles={customStyles}
      // value={options.filter((option) => default_options.includes(option.value))}
    ></Select>
  </div>
);

export default TickerSearchBox;
